import { AppRegistry } from 'react-native';
import { AppName } from '../src';
import App from './WebApp';

AppRegistry.registerComponent(AppName, () => App);
AppRegistry.runApplication(AppName, {
  rootTag: document.getElementById('root'),
});
